import React from 'react'

import { Checkbox } from '@frame/ui-primitives/checkbox'
import { P } from '@frame/ui-primitives/p'

type Props = {
  value: string
  label: string
  isSelected: boolean
  onChange: () => void
}

export function MultipleSelectOption({ value, label, isSelected, onChange }: Props) {
  return (
    <div
      className="flex cursor-pointer select-none items-center gap-1 rounded-md border border-moss-300 p-4 transition-colors"
      onClick={onChange}
    >
      <Checkbox checked={isSelected} label="" value={value} />
      <P className="font-semibold">{label}</P>
    </div>
  )
}
